import {
  MessageBox
} from 'element-ui'

var ElMessageBox = MessageBox
var EL_MESSAGE_DEFAULT = {
  duration: 5000,
  showClose: true,
  customClass: 'my-el-message-font'
}
ElMessageBox = function (options) {
  if (typeof (options) === 'object') {
    options = Object.assign({}, EL_MESSAGE_DEFAULT, options)
  }
  MessageBox(options)
}

export default ElMessageBox



// WEBPACK FOOTER //
// ./src/third/ElMessageBox.js